import React, {FC, ReactNode} from 'react';

import {Trans} from '../../../../../../libs/shared/core/src/helpers/internationalization/react';
import {useEventHandler} from '../../../../../../libs/shared/core/src/helpers/react/hooks/useEventHandler';
import {SnoozeLocationsEnum} from '../../../../../../libs/shared/core/src/services/tracking/tracking';
import {getTimeFormat} from '../../../../../../libs/shared/core/src/store/data/preferences/commonPreferencesSelectors';
import {DropdownInheritableProps} from '../../../../../../libs/shared/ui/src/components/dropdowns/dropdown';
import {useAppDispatch, useAppSelector} from '../../../../../helpers/appReduxHelpers';
import {
  getCustomSnoozes,
  getReminderPresets,
  getReminderValues,
} from '../../../../../store/data/preferences/preferencesSelectors';
import {navigateToSnoozesAction} from '../../../../../store/stateless/navigationActions';
import {FutureTimeDropdown} from '../../../../common/futureTime/futureTimeDropdown';

/*
 * Props.
 */

interface ReminderDropdownProps extends DropdownInheritableProps {
  onValueSelect: (sendAt: number) => void;
  onBackClick?: () => void;
  backLabel?: ReactNode;
}

/*
 * Component.
 */

export const ReminderDropdown: FC<ReminderDropdownProps> = (props) => {
  const values = useAppSelector(getReminderValues);
  const reminderPresets = useAppSelector(getReminderPresets);
  const customSnoozes = useAppSelector(getCustomSnoozes);
  const timeFormat = useAppSelector(getTimeFormat);

  const dispatch = useAppDispatch();
  const onSettingsClick = useEventHandler(() => {
    dispatch(navigateToSnoozesAction());
  });

  return (
    <FutureTimeDropdown
      {...props}
      title={<Trans id="composer-send-snooze">Send &amp; Snooze</Trans>}
      selectButton={<Trans id="composer-send">Send</Trans>}
      values={values}
      reminderPresets={reminderPresets}
      customSnoozes={customSnoozes}
      timeFormat={timeFormat}
      location={SnoozeLocationsEnum.SEND_AND_SNOOZE}
      onOpenSnoozesClick={onSettingsClick}
      onBackClick={props.onBackClick}
      backLabel={props.backLabel}
    />
  );
};
